import { getForwardChannelIds, getForwardSearchInput } from 'gcs-common/slices/channelList/channelListSelectors';
import { setForwardSearchInput } from 'gcs-common/slices/channelList/channelListSlice';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { useSelector } from 'react-redux';
import { Virtuoso } from 'react-virtuoso';
import ChannelSearchInput from '../AgentChannelList/ChannelSearchInput/ChannelSearchInput';
import ForwardChannelListHeader from '../ForwardChannelListHeader/ForwardChannelListHeader';
import ForwardChannelListItem from '../ForwardChannelListItem/ForwardChannelListItem';
import styles from './styles.module.scss';

interface ForwardChannelListProps {
  forwardingFromEts?: boolean | false;
}

const ForwardChannelList = (props: ForwardChannelListProps) => {
  const { forwardingFromEts } = props;
  const selectedChannelId = useSelector(getSelectedChannelId);
  const forwardChannelIds = useSelector(getForwardChannelIds(forwardingFromEts ? undefined : selectedChannelId));
  const forwardSearchInput = useSelector(getForwardSearchInput);

  return (
    <div className={styles.forwardMessageWrapper} style={{ position: forwardingFromEts ? 'unset' : 'absolute' }}>
      <ForwardChannelListHeader forwardingFromEts={forwardingFromEts} />
      <ChannelSearchInput
        type="forwardSearchInput"
        getSearchInput={getForwardSearchInput}
        setSearchInput={setForwardSearchInput}
        light
        forwardingFromEts
      />
      {(!forwardSearchInput || forwardSearchInput.length === 0) && <div className={styles.title}>LETZTE CHATS</div>}
      <div className={styles.channelListWrapper}>
        <Virtuoso
          data={forwardChannelIds}
          itemContent={(_, channelId) => (
            <ForwardChannelListItem channelId={channelId} forwardingFromEts={forwardingFromEts} />
          )}
        />
      </div>
      {!forwardingFromEts && <div className={styles.whitespacePadding} />}
    </div>
  );
};

export default ForwardChannelList;
